import { getAPIToken } from "../apis/firebaseAuthentication";
import { MOCK_ZONES, MOCK_DOS } from "../mock/fieldSurveyMock";
// ZONEの初期値
const initialZone = {
    zone_data: {},
    count: 0,
};
const zoneData = {
    // ZONE
    zone: initialZone,
};
// ZONE情報の全量の情報を返す
export const getAllZone = () => {
    return zoneData.zone;
};
// DOの初期値
const initialDo = {
    do_data: {},
    count: 0,
};
const doData = {
    // DO
    do: initialDo,
};
// DO情報の全量の情報を返す
export const getAllDo = () => {
    return doData.do;
};
/**
 * APIからZOデータを取得する
 */
export async function loadZoDataFromApi() {
    try {
        const domain = process.env.SEVEN_CENTRAL_INHOUSE_URL;
        const url = `${domain}j21spb32/v1/zone/list`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + (await getAPIToken(true))
            },
            body: JSON.stringify({})
        });
        if (!response.ok) {
            throw new Error(`API request failed: ${response.status} ${response.statusText}`);
        }
        const apiResponse = await response.json();
        // dataフィールドは文字列化されたJSON配列なのでパースする
        const zoneRecord = apiResponse.zone_list;
        const zoneRecordData = {};
        for (let i = 0; i < zoneRecord.length; i++) {
            // zone_code が "092" のデータを除外
            if (zoneRecord[i].zone_code !== "092") {
                zoneRecordData[zoneRecord[i].zone_code] = zoneRecord[i];
            }
        }
        const count_zone = Object.keys(zoneRecordData).length;
        const zone = {
            zone_data: zoneRecordData,
            count: count_zone,
        };
        zoneData.zone = zone;
    }
    catch (error) {
        console.error('Error loading ZO data from API:', error);
    }
}
/**
 * APIからDOデータを取得する
 */
export async function loadDoDataFromApi() {
    try {
        const domain = process.env.SEVEN_CENTRAL_INHOUSE_URL;
        const url = `${domain}j21spb32/v1/do/list`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + (await getAPIToken(true))
            },
            body: JSON.stringify({})
        });
        if (!response.ok) {
            throw new Error(`API request failed: ${response.status} ${response.statusText}`);
        }
        const apiResponse = await response.json();
        // dataフィールドは文字列化されたJSON配列なのでパースする
        const doRecord = apiResponse.do_list;
        const doRecordData = {};
        for (let i = 0; i < doRecord.length; i++) {
            // do_code が "00088" のデータを除外
            if (doRecord[i].do_code !== "00088") {
                doRecordData[doRecord[i].do_code] = doRecord[i];
            }
        }
        const count_do = Object.keys(doRecordData).length;
        const dodo = {
            do_data: doRecordData,
            count: count_do,
        };
        doData.do = dodo;
    }
    catch (error) {
        console.error('Error loading DO data from API:', error);
    }
}
/**
 * モック: ダミーのZOデータをセットする（通信しない）
 */
export async function loadMockZoData() {
    const zoneRecordData = {};
    MOCK_ZONES.forEach(z => { zoneRecordData[z.zone_code] = z; });
    zoneData.zone = { zone_data: zoneRecordData, count: MOCK_ZONES.length };
}
/**
 * モック: ダミーのDOデータをセットする（通信しない）
 */
export async function loadMockDoData() {
    const doRecordData = {};
    MOCK_DOS.forEach(d => { doRecordData[d.do_code] = d; });
    doData.do = { do_data: doRecordData, count: MOCK_DOS.length };
}
